module.exports = __webpack_public_path__ + "static/img/icon7.a6bb0593.png";